import take from 'lodash/take';
import size from 'lodash/size';

import { useCurrentUser } from '../../../../../../../auth/hooks/useAuth';

import { CompanyOperationsCompactTableRowFileAttachmentsOperation } from './CompanyOperationsCompactTableRowFileAttachments.types';

import { LinkHelper } from '../../../../../../../helpers/links/LinkHelper';
import { Icon } from '../../../../../../../helpers/Icon';

import { getFileIcon } from '../../../../../../../utils/getFileIcon';
import { getFileAttachmentName } from '../../../../../../fileAttachments/utils/getFileAttachmentName';

import { TeamsPermissions } from '../../../../../../teams/teamsConstants';

const MAX_SHOW_COUNT = 2;

interface CompanyOperationsCompactTableRowFileAttachmentsProps {
  operation: CompanyOperationsCompactTableRowFileAttachmentsOperation;
}

function CompanyOperationsCompactTableRowFileAttachments({
  operation
}: CompanyOperationsCompactTableRowFileAttachmentsProps) {
  const currentUser = useCurrentUser();

  const allFileAttachments = operation.fileAttachments;

  const visibleFileAttachment = take(operation.fileAttachments, MAX_SHOW_COUNT);

  const hiddenFileAttachmentsCount =
    size(allFileAttachments) - size(visibleFileAttachment);

  return (
    <div className="flex items-center gap-1 mt-0.5">
      {visibleFileAttachment.map((fileAttachment) => (
        <div
          key={fileAttachment.uuid}
          className="max-w-40 shrink flex rounded border dark:border-gray-700 text-sm overflow-hidden relative focus-within:ring-base"
        >
          <div className="h-6 w-6 relative border-r dark:border-gray-700 box-content flex">
            <div className="absolute inset-0 p-1 bg-gray-100 dark:bg-gray-800">
              <Icon
                icon={getFileIcon(fileAttachment.file)}
                className="w-4 h-4"
              />
            </div>
          </div>

          <div className="flex-1 truncate p-0.5 leading-5 bg-white dark:bg-gray-900">
            {currentUser.hasPermissions(
              TeamsPermissions.READ_COMPANY_OPERATION_FILE_DOWNLOAD_LINK
            ) ? (
              <LinkHelper
                key={fileAttachment.uuid}
                href={fileAttachment.file}
                target="_blank"
                className="focus-visible:outline-none"
              >
                {getFileAttachmentName(fileAttachment)}
                <span className="absolute inset-0" />
              </LinkHelper>
            ) : (
              <div className="focus-visible:outline-none">
                {getFileAttachmentName(fileAttachment)}
              </div>
            )}
          </div>
        </div>
      ))}

      {hiddenFileAttachmentsCount ? (
        <div className="px-1 rounded border dark:border-gray-700 flex items-center justify-center hover:bg-gray-200 min-w-6 self-stretch">
          {`+${hiddenFileAttachmentsCount}`}
        </div>
      ) : null}
    </div>
  );
}

export default CompanyOperationsCompactTableRowFileAttachments;
